import React from "react";
import "./read-more-btn.m.css";
import PT from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

function ReadMoreBtnBase(props) {
  const readMoreDefaultText = lang => {
    switch (lang) {
      case "hi":
        return "अधिक पढ़ें";
      case "ur":
        return "مزید پڑھیں";
      default:
        return "Read More";
    }
  };

  const readMoreUrl = () => {
    return props.collectionTemplate === "section"
      ? `/section/${props.collectionSlug}`
      : `/collection/${props.collectionSlug}`;
  };

  const readMoreClassName = () => {
    return props.darkTheme ? "read-more-dark" : "read-more";
  };
  const readMoreSpaceStyle = () => {
    return props.readMoreSpace ? "read-more-space" : "";
  };
  if (!props.collectionSlug && !props.collectionTemplate) {
    return null;
  }
  return (
    <div styleName={`read-more-wrapper ${readMoreSpaceStyle()}`}>
      <a styleName={readMoreClassName()} href={readMoreUrl()} target="_blank" rel="noopener noreferrer">
        {!props.readMoreText || props.readMoreText === ""
          ? readMoreDefaultText(props.publisherAttributes.lang)
          : props.readMoreText}
      </a>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    pageType: get(state, ["qt", "pageType"], []) || "",
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], "") || {}
  };
}

ReadMoreBtnBase.propTypes = {
  href: PT.string,
  collectionTemplate: PT.object,
  collectionSlug: PT.string,
  darkTheme: PT.bool,
  readMoreSpace: PT.bool,
  publisherAttributes: PT.string,
  readMoreText: PT.string
};

export const ReadMoreBtn = connect(
  mapStateToProps,
  null
)(ReadMoreBtnBase);
